import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { map, shareReplay } from "rxjs/operators";
import { ActivityTemplate } from "../models/activityTemplate";
import { Activity } from "../models/activity";

@Injectable({
  providedIn: "root"
})
export class ActivityService {

  private createHeader() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return httpOptions;
  }

  constructor(private httpClient: HttpClient) { }

  getActivityTemplatesByYear(year: number): Observable<ActivityTemplate[]>  {
    return this.httpClient.get<ActivityTemplate[]>(`${environment.ApiEndpoint}/Activity/GetActivitiesTemplateByYear?year=`+year, this.createHeader())
      .pipe(map(results => {
        const newArray =  results.sort(function(a, b){
          const nameA = a.Name.toLowerCase(), nameB = b.Name.toLowerCase();
          if(nameA === "other")
            return 1;
          if(nameB === "other")
            return -1
          if (nameA < nameB)
           return -1;
          if (nameA > nameB)
           return 1;
          return 0;
         });

         return newArray;
      })).pipe(shareReplay(1));
  }

  getActivities(competencyId: string): Observable<Activity[]> {
    return this.httpClient.get<Activity[]>(`${environment.ApiEndpoint}/Activity/GetActivitiesByCompetencyId?competencyId=` + competencyId, this.createHeader());
  }

  postActivity(activity: Activity): Observable<Activity> {
    return this.httpClient.post<Activity>(`${environment.ApiEndpoint}/Activity/CreateActivity`, activity, this.createHeader());
  }
  
  putActivity(activity: Activity): Observable<Activity> {
    return this.httpClient.put<Activity>(`${environment.ApiEndpoint}/Activity/UpdateActivity`, activity, this.createHeader());
  }

  deleteActivity(competency: Activity) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: competency
    };
    return this.httpClient.request('DELETE', `${environment.ApiEndpoint}/Activity/DeleteActivity`, httpOptions);
  }

  scrubActivity(activity: Activity) : Activity{
    const clone = JSON.parse(JSON.stringify(activity));
    clone.Notes = clone.Notes?.replace(/./g, x => x);
    return clone;
  }
}